import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

type ThisApi = ApiDefinition['/creators/{creatorId}/creator-billing-invoices']['GET'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

const getCreatorBillingInvoicesCsv = async ({ creatorId }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/creators/{creatorId}/creator-billing-invoices', { creatorId });
  const response = await noodleApiClient.get(path);
  return response.data as Output;
};

export default getCreatorBillingInvoicesCsv;
